import angular from 'angular';
import _ from 'lodash';
import logger from '../../../../../shared/logger';

export const TESourcingProductivityService = (StatsService, $filter, WorkflowService) => {
    const getTESourcingProductivityData = function (fromDate, toDate, recruiterId, targets, numberToDivide, numberOfRecruiters, callback) {
        const requestBody = {
            from: fromDate,
        };
        if (toDate) {
            requestBody.to = toDate;
        }
        if (recruiterId) {
            requestBody.recruiterIds = [recruiterId];
        } else {
            requestBody.allRecruiters = true;
        }
        StatsService.getTalentExpertSourcingProductivityByTimeFrame(requestBody)
            .then((response) => {
                const diffDate = numberToDivide / 30;
                const dataSource = [{
                    state: $filter('translate')('DASHBOARD_GRAPHS_MESSAGES'),
                    average: 0,
                    target: 0,
                }, {
                    state: $filter('translate')('DASHBOARD_GRAPHS_SENT_TO_CANDIDATE'),
                    average: 0,
                    target: 0,
                }, {
                    state: $filter('translate')('DASHBOARD_GRAPHS_SENT_PROFILES'),
                    average: 0,
                    target: 0,
                }, {
                    state: $filter('translate')('DASHBOARD_GRAPHS_SENT_PLACEMENTS'),
                    average: 0,
                    target: 0,
                }];
                const averageDate = response.result;
                let talentExpertSourcingProductivity = _.find(targets, 'talentExpertSourcingProductivity');

                if (talentExpertSourcingProductivity && talentExpertSourcingProductivity.talentExpertSourcingProductivity) {
                    talentExpertSourcingProductivity = talentExpertSourcingProductivity.talentExpertSourcingProductivity;
                }

                const messages = _.find(averageDate, { status: 'messages' });
                if (messages) {
                    dataSource[0].average = messages.count;
                }
                if (talentExpertSourcingProductivity && talentExpertSourcingProductivity.messages) {
                    if (recruiterId) {
                        dataSource[0].target = Math.floor(talentExpertSourcingProductivity.messages * diffDate);
                    } else {
                        dataSource[0].target = Math.floor(talentExpertSourcingProductivity.messages * diffDate * numberOfRecruiters);
                    }
                }

                const sendToCandidate = _.find(averageDate, { status: WorkflowService.eventTypes.TALENT_EXPERT_SENT_RESUME_TO_CANDIDATE });
                if (sendToCandidate) {
                    dataSource[1].average = sendToCandidate.count;
                }
                if (talentExpertSourcingProductivity && talentExpertSourcingProductivity.profilesEnhanced) {
                    if (recruiterId) {
                        dataSource[1].target = Math.floor(talentExpertSourcingProductivity.profilesEnhanced * diffDate);
                    } else {
                        dataSource[1].target = Math.floor(talentExpertSourcingProductivity.profilesEnhanced * diffDate * numberOfRecruiters);
                    }
                }

                const sentProfiles = _.find(averageDate, { status: 'Prospect' });
                if (sentProfiles) {
                    dataSource[2].average = sentProfiles.count;
                }
                if (talentExpertSourcingProductivity && talentExpertSourcingProductivity.profilesSent) {
                    if (recruiterId) {
                        dataSource[2].target = Math.floor(talentExpertSourcingProductivity.profilesSent * diffDate);
                    } else {
                        dataSource[2].target = Math.floor(talentExpertSourcingProductivity.profilesSent * diffDate * numberOfRecruiters);
                    }
                }

                const placements = _.find(averageDate, { status: 'Hired' });
                if (placements) {
                    dataSource[3].average = placements.count;
                }
                if (talentExpertSourcingProductivity && talentExpertSourcingProductivity.placements) {
                    if (recruiterId) {
                        dataSource[3].target = Math.floor(talentExpertSourcingProductivity.placements * diffDate);
                    } else {
                        dataSource[3].target = Math.floor(talentExpertSourcingProductivity.placements * diffDate * numberOfRecruiters);
                    }
                }
                const TE = $filter('translate')('SOURCING_PRODUCTIVITY_TARGET_TES_AVERAGE');
                const Tar = $filter('translate')('SOURCING_PRODUCTIVITY_TARGET');
                const options = {
                    palette: 'soft',
                    equalBarWidth: true,
                    size: {
                        height: 238,
                    },
                    dataSource,
                    commonSeriesSettings: {
                        argumentField: 'state',
                        type: 'bar',
                    },
                    commonAxisSettings: {
                        label: {
                            visible: true, // Show text labels
                            font: {
                                color: '#000000',
                                family: 'Source Sans Pro',
                                weight: 400,
                                size: 12,
                            },
                        },
                        tickInterval: 5,
                    },
                    series: [
                        {
                            valueField: 'average',
                            name: TE,
                            color: '#4362A4'
                        },
                        {
                            valueField: 'target',
                            name: Tar,
                            color: '#91A8D8'
                        },
                    ],
                    legend: {
                        verticalAlignment: 'bottom',
                        horizontalAlignment: 'center',
                        itemTextPosition: 'right',
                        font: {
                            color: '#000000',
                            family: 'Source Sans Pro',
                            weight: 400,
                            size: 15,
                        },
                        margin: {
                            top: 33,
                        },
                    },
                    tooltip: {
                        enabled: true,
                        paddingLeftRight: 12,
                        paddingTopBottom: 10,
                        customizeTooltip(arg) {
                            return {
                                text: arg.valueText,
                            };
                        },
                    },
                };

                callback({
                    options,
                });
            })
            .catch(err => logger.error(err));
    };


    return {
        getTESourcingProductivityData,
    };
};

angular
    .module('TALENYA-FE')
    .factory('TESourcingProductivityService', TESourcingProductivityService);
